/* eslint-disable react/jsx-props-no-spreading */
import React, { useRef } from 'react';
import styled from 'styled-components';
import { select, withQuery } from '../../core/themev2';
import { forkRef } from '../../helpers/forkedRefs';
import { NumericInput } from './numericInput';
import { FeatureLabel } from './styles';

const FeatureOptions = styled.div`
  position: relative;
  height: 66px;
  width: 128px;
  ${withQuery.xs.down()} {
    width: 100%;
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    height: auto;
    margin: 25px 0px 0px;
    &:first-child {
      margin: 0px;
    }
  }
`;

const Options = styled.div`
  position: relative;
  ${withQuery.xs.down()} {
    display: inline-block;
  }
`;

const ButtonRight = styled.div`
  width: 32px;
  height: 32px;
  background: ${select('middleGray')};
  border-radius: 4px;
  position: absolute;
  right: 4px;
  top: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  :hover {
    background: ${select('midLightGray')};
  }
  &.disabled {
    background: ${select('lightGray')};
    color: ${select('midLightGray')};
    cursor: not-allowed;
    :active {
      pointer-events: none;
    }
  }
  ${withQuery.xs.down()} {
    width: 48px;
    height: 48px;
    font-size: 22px;
    border-radius: 12px;
  }
`;

const ButtonLeft = styled(ButtonRight)`
  left: 4px;
`;

const FeatureInput = styled(NumericInput)`
  border: 1px solid ${select('middleGray')};
  border-radius: 8px;
  width: 128px;
  height: 40px;
  text-align: center;
  :focus {
    outline: none;
  }
  ${withQuery.xs.down()} {
    height: 56px;
    width: 100%;
    border-radius: 13px;
  }
`;

const IncrementableInput = React.memo(
  React.forwardRef((props, propRef) => {
    const {
      label,
      isOptional = true,
      name,
      disableOnMin = false,
      minValue = 0,
      maxValue = 10,
      inputprops,
      setVal,
      ...restProps
    } = props;
    const inputRef = useRef();
    const onIncrement = () => {
      const currentValue = parseInt(inputRef.current.value) || 0;
      if (parseInt(maxValue, 10) > parseInt(inputRef.current.value)) {
        if (setVal) {
          setVal(name, currentValue + 1);
        } else {
          inputRef.current.value = currentValue + 1;
        }
      }
    };
    const onDecrement = () => {
      const currentValue = parseInt(inputRef.current.value) || 0;
      if (parseInt(minValue, 10) < parseInt(inputRef.current.value)) {
        if (setVal) {
          setVal(name, currentValue - 1);
        } else {
          inputRef.current.value = currentValue - 1;
        }
      }
    };
    return (
      <FeatureOptions>
        <FeatureLabel htmlFor={name}>
          {label} {isOptional && `(opcional)`}
        </FeatureLabel>
        <Options>
          <ButtonLeft
            onClick={onDecrement}
            className={disableOnMin && inputRef.current && inputRef.current.value === minValue && 'disabled'}
          >
            -
          </ButtonLeft>
          <FeatureInput
            onChange={e => {
              if (!e.target.value) {
                e.target.value = 0;
              } else {
                e.target.value = parseInt(e.target.value);
              }
            }}
            min={0}
            max={10}
            name={name}
            ref={forkRef(inputRef, propRef)}
            {...inputprops}
            {...restProps}
          />
          <ButtonRight
            onClick={onIncrement}
            className={disableOnMin && inputRef.current && inputRef.current.value === maxValue && 'disabled'}
          >
            +
          </ButtonRight>
        </Options>
      </FeatureOptions>
    );
  })
);

export { IncrementableInput };
